import React from 'react';
import CustomCarouselDots from './index';

const appendDots = (props: { dots: JSX.Element[]; cardsCount: number; activeCardIndex: number; showCustomDots: boolean }): JSX.Element => {
  const { dots, cardsCount, activeCardIndex, showCustomDots } = props;
  if (showCustomDots) {
    return <CustomCarouselDots cardsCount={cardsCount} activeCard={activeCardIndex + 1} />;
  }
  return <ul>{dots}</ul>;
};

export default appendDots;
